import { Link } from 'react-router-dom';

const benefits = [
  'Exclusive access to property owner network in your area',
  'Competitive compensation for quality work',
  'Flexible scheduling and project selection',
  'Marketing support and lead generation',
  'Training on Airbnb-specific requirements',
  'Ongoing business development opportunities'
];

export default function VendorPartnership() {
  return (
    <section className="py-24 bg-[#FF6B6B] relative overflow-hidden">
      {/* Decorative Pattern */}
      <div className="absolute right-0 top-0 bottom-0 w-2/5 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 border-2 border-white/80 text-white text-sm font-semibold rounded-full mb-6">
              Join Our Network
            </div>
            
            <h2 className="text-5xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Become a Local Vendor Partner
            </h2>

            <div className="space-y-4 mb-10">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-xl"></i>
                  </div>
                  <p className="text-white text-lg">
                    {benefit}
                  </p>
                </div>
              ))}
            </div>

            <Link 
              to="/contact"
              className="inline-block border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-[#FF6B6B] transition-all cursor-pointer whitespace-nowrap"
            >
              Apply Now
            </Link>

            <p className="text-white/90 text-sm mt-4">
              <i className="ri-map-pin-line mr-1"></i>
              Limited spots available in your area
            </p>
          </div>

          <div className="hidden lg:block">
            {/* Decorative element placeholder */}
          </div>
        </div>
      </div>
    </section>
  );
}
